"use client";

// packages/eden-table/src/components/TBody.jsx
import TableSectionContext from './Table/TableSectionContext.js';
import { jsx } from "react/jsx-runtime";
var TBody = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx("tbody", { ...props, children: /* @__PURE__ */ jsx(TableSectionContext.Provider, { value: "tbody", children }) });
};
TBody.displayName = "TBody";
var TBody_default = TBody;
export {
  TBody_default as default
};
